import { computed } from 'vue';
import { useNuxtApp } from 'nuxt/app';
import { DELIVERY_AREA_MODEL } from '~~/shop/app/config/DeliveryMethodConfig';
import { useDeliveryStore } from '~~/shop/app/stores/delivery';
import { useModalStore } from '~~/common/stores/modal';

export function useDeliveryTimeSlot () {
  const deliveryMethod = computed(() => {
    return useDeliveryStore().setup;
  });
  const getDeliveryLocation = computed(() => {
    const { type, name, postCode, deliveryMethodType } = deliveryMethod.value || {};
    if (type === DELIVERY_AREA_MODEL.PICK_UP_FROM_STORE || (type === DELIVERY_AREA_MODEL.PUBLIC_AREA && deliveryMethodType)) {
      return name;
    }
    return postCode + ' ' + name;
  });
  const getDeliveryLocationPrefix = computed(() => {
    const { $awt } = useNuxtApp();

    return $awt(deliveryMethod.value?.type === DELIVERY_AREA_MODEL.PICK_UP_FROM_STORE
      ? 'aw.common.header.time_slot_btn.store_here'
      : deliveryMethod.value?.deliveryMethodType ? `aw.common.header.time_slot_btn.${deliveryMethod.value?.deliveryMethodType}` : 'aw.common.header.time_slot_btn.deliver_here',
    );
  });
  const getDeliveryLocationText = computed(() => {
    return (deliveryMethod.value
      ? `${getDeliveryLocationPrefix.value} ${getDeliveryLocation.value}`
      : ''
    );
  });

  return {
    getDeliveryLocationText,
  };
}

type DeliveryModalPayload = Parameters<ReturnType<typeof useModalStore>['openDeliveryMethodModal']>[0];

export function openDeliveryModal (payload?: DeliveryModalPayload) {
  const modalStore = useModalStore();
  modalStore.openDeliveryMethodModal(payload);
}
